export default "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?7484a6c648c26cc63e736c99aa36910e";